import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29a83d8f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "top_title_class" }
const _hoisted_2 = { class: "left_div_class" }
const _hoisted_3 = { class: "right_div_class" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.showTopBar)
      ? (_openBlock(), _createBlock(_component_van_nav_bar, {
          key: 0,
          title: _ctx.$t('竞猜记录'),
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
        }, null, 8 /* PROPS */, ["title"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString($setup.t('比赛')), 1 /* TEXT */),
      _createElementVNode("p", null, _toDisplayString($setup.t('竞猜结果')), 1 /* TEXT */)
    ]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: $setup.refreshing,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.refreshing) = $event)),
      onRefresh: $setup.onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          modelValue: $setup.loading,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loading) = $event)),
          finished: $setup.finished,
          "finished-text": "",
          class: "van-list-class"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.matches, (item, index) => {
              return (_openBlock(), _createBlock(_component_van_cell, {
                key: item.match_id,
                class: "match-cell",
                clickable: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", {
                    class: "cell_super_class",
                    style: _normalizeStyle({backgroundColor: (index % 2==0) ? 'white' : '#F8F8F8'})
                  }, [
                    _createElementVNode("div", _hoisted_2, [
                      _createElementVNode("p", null, _toDisplayString($setup.getMatchName(item)), 1 /* TEXT */),
                      _createElementVNode("p", null, _toDisplayString(item.match_time), 1 /* TEXT */)
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("p", {
                        style: _normalizeStyle({color: item.guess_result == 'pending' ? 'rgba(35, 24, 22, 0.5)' : 'rgba(35, 24, 22, 1)' })
                      }, _toDisplayString($setup.guessState(item)), 5 /* TEXT, STYLE */),
                      _createElementVNode("p", {
                        style: _normalizeStyle({color:item.bonus>0?'#FF0000':'#04CB63'})
                      }, _toDisplayString(item.bonus == 0 ? '' : item.bonus), 5 /* TEXT, STYLE */)
                    ])
                  ], 4 /* STYLE */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue", "finished"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}